module.exports = __webpack_public_path__ + "img/back_1000.1ec55c89.jpg";